import { MultiplicityPatterns } from 'nmr-processing';
export const Multiplets = MultiplicityPatterns.map(({ label, value, acs, multiplicity }) => ({
    label,
    value: acs || value,
    multiplicity,
}));
